// extracted by mini-css-extract-plugin
export var button = "ListPagination-module--button--67440";
export var container = "ListPagination-module--container--e893e";
export var disabled = "ListPagination-module--disabled--8f82c";
export var ellipsis = "ListPagination-module--ellipsis--cc845";
export var label = "ListPagination-module--label--993d0";
export var numbers = "ListPagination-module--numbers--e9b72";
export var pageNumber = "ListPagination-module--pageNumber--5f1ce";
export var selected = "ListPagination-module--selected--59c6b";